(() => {
	angular.module('main').controller('HomeController', HomeController);

	HomeController.$inject = [
		'$scope',
		'$rootScope',
		'$timeout',
		'$http',
		'$q',
		'$location',
		'messageService',
		'jobDataService',
		'workflowService',
		'extraShootService',
		'appointmentService',
		'timeService',
		'accountService',
		'jobTypesDataService',
		'workflowDataService',
		'settingsService',
		'utilsService',
		'templateRequestsService',
		'clientService',
		'timeConverter'
	];

	function HomeController(
		$scope,
		$rootScope,
		$timeout,
		$http,
		$q,
		$location,
		messageService,
		jobDataService,
		workflowService,
		extraShootService,
		appointmentService,
		timeService,
		accountService,
		jobTypesDataService,
		workflowDataService,
		settingsService,
		utilsService,
		templateRequestsService,
		clientService,
		timeConverter
	) {
		$scope.$watch('$viewContentLoaded', event => {
			$scope.unsubscribe = new Rx.Subject();
			$scope.now = new Date();
			getUser();
			getCompanyId();
			$scope.now.setHours(12, 0, 0, 0);
			$scope.workflowNames = [];
			$scope.isAddNewSpinnningWheelActive = false;
		});

		$scope.$on('$destroy', () => {
			$scope.userObservable.unsubscribe();
			$scope.unsubscribe.next();
			$scope.unsubscribe.complete();
			$scope.jobTypesSubscription.unsubscribe();
		});

		$scope.isDisabled = true;
		$scope.activeJobs = [];

		function getUser() {
			$scope.userObservable = accountService.userDataObservable.subscribe(
				user => {
					if (user !== null && typeof user !== 'undefined') {
						$scope.user = JSON.parse(JSON.stringify(user));
						showSpecialModals();
					}
				}
			);
		}

		function getCompanyId() {
			accountService.companyIdObservable
				.takeUntil($scope.unsubscribe)
				.subscribe(data => {
					$scope.companyId = data;
					getJobTypes();
				});
		}

		function showSpecialModals() {
			const defaultTitle = 'Happiness is an unlimited Studio Ninja account.';
			$scope.trialModalTitle = defaultTitle;

			if ($rootScope.showThanks || $rootScope.showThanksModal) {
				showThanksModal();
			} else if ($scope.user.inTrial && $rootScope.showTrialModal) {
				showTrialModal(defaultTitle);
			} else if (
				$scope.user.subscription.plan &&
				$scope.user.subscription.freeDaysAccess > 0 &&
				$rootScope.showTrialModal
			) {
				showGracePeriodModal(defaultTitle);
			}

			delete $rootScope.showTrialModal;
		}

		function showThanksModal() {
			$timeout(() => {
				$('#thanksModal').modal('show');

				$timeout(() => {
					$rootScope.showThanks = false;
					$rootScope.showThanksModal = false;
				}, 5);
			}, 450);
		}

		function showTrialModal(defaultTitle) {
			const items = $rootScope.trialModalTitles;
			const randomTitle = items[Math.floor(Math.random() * items.length)];
			$scope.trialModalTitle = randomTitle || defaultTitle;

			$('#trialModal').modal('show');
		}

		function showGracePeriodModal(defaultTitle) {
			$scope.trialModalTitle = defaultTitle;
			$('#trialModal').modal('show');
		}

		$scope.$watch('totalInvoicedDateItem', (newValue, oldValue) => {
			if (newValue != oldValue && newValue !== undefined) {
				$http
					.get(
						`/protected/rest/dashboard/get/total/invoiced?dateItem=${newValue}`
					)
					.then(
						result => {
							$rootScope.rootTotalInvoicedDateItem = newValue;
							if (result.data) {
								$rootScope.totalInvoiced = result.data;
								$scope.data.totalInvoiced = result.data;
							} else if (result.data === 0) {
								$rootScope.totalInvoiced = 0;
								$scope.data.totalInvoiced = result.data;
							}
						},
						() => {}
					);
			}
		});
		$scope.$watch('jobsLeadDateItem', (newValue, oldValue) => {
			if (newValue != oldValue && newValue !== undefined) {
				$http
					.get(`/protected/rest/dashboard/get/jobs/leads?dateItem=${newValue}`)
					.then(result => {
						$rootScope.rootJobsLeadDateItem = newValue;
						if (result.data) {
							$rootScope.jobsLead = result.data;
							$scope.data.jobsLead = result.data;
						} else if (result.data === 0) {
							$rootScope.jobsLead = 0;
							$scope.data.jobsLead = result.data;
						}
					});
			}
		});
		$scope.$watch('jobsAcceptedDateItem', (newValue, oldValue) => {
			if (newValue != oldValue && newValue !== undefined) {
				$http
					.get(
						`/protected/rest/dashboard/get/jobs/accepted?dateItem=${newValue}`
					)
					.then(result => {
						$rootScope.rootJobsAcceptedDateItem = newValue;
						if (result.data) {
							$rootScope.jobsAccepted = result.data;
							$scope.data.jobsAccepted = result.data;
						} else if (result.data === 0) {
							$rootScope.jobsAccepted = 0;
							$scope.data.jobsAccepted = result.data;
						}
					});
			}
		});

		$scope.$watch('jobsScheduledDateItem', (newValue, oldValue) => {
			if (newValue != oldValue && newValue !== undefined) {
				$http
					.get(
						`/protected/rest/dashboard/get/jobs/scheduled?dateItem=${newValue}`
					)
					.then(result => {
						$rootScope.rootJobsScheduledDateItem = newValue;
						if (result.data) {
							$rootScope.jobsScheduled = result.data;
							$scope.data.jobsScheduled = result.data;
						} else if (result.data === 0) {
							$rootScope.jobsScheduled = 0;
							$scope.data.jobsScheduled = result.data;
						}
					});
			}
		});

		$scope.showJob = function(jobId) {
			if (jobId !== null) {
				$location.path(`jobs/view/${jobId}`);
			}
		};

		$scope.chooseModalHandler = function(event) {
			getActiveJobs().then(() => {
				chooseEventModal(event);
			});
		};

		function isAppointment(event) {
			return event.calendarEventType === 'APPOINTMENT';
		}

		function isJob(event) {
			return event.calendarEventType === 'MAIN_SHOOT';
		}

		function isExtraShoot(event) {
			return event.calendarEventType === 'EXTRA_SHOOT';
		}

		function chooseEventModal(event) {
			if (typeof event === 'undefined' || event === null) {
				return;
			}

			if (isJob(event) || (isAppointment(event) && event.jobId)) {
				$location.path(`jobs/view/${event.jobId}`);
			} else if (isAppointment(event)) {
				appointmentService
					.prepareAppointmentToShow(event)
					.subscribe(appointment => {
						workflowService.setTaskInfo(appointment);
						$('#appointment').modal('show');
					});
			} else if (isExtraShoot(event)) {
				const extraShoot = extraShootService.prepareExtraShootToShow(event);
				workflowService.setTaskInfo(extraShoot);
				$('#extraShootModal').modal('show');
			} else {
				workflowService.setTaskInfo({});
				$('#appointment').modal('show');
			}
		}

		$scope.showInvoice = function(id) {
			$location.path(`invoices/${id}`);
		};

		$scope.hideHelp = function(id) {};

		function getJobTypes() {
			$scope.jobTypesSubscription = jobTypesDataService
				.getJobTypes()
				.subscribe(data => successGetJobTypes(data));
		}

		function successGetJobTypes(data) {
			$scope.jobTypes = angular.copy(data);

			const defaultType = data.find(type => type.default === true);
			if (defaultType) {
				$scope.defaultJobType = defaultType;
			}

			if (!localStorage.getItem(`dashboardJobType${$scope.companyId}`)) {
				localStorage.setItem(
					`dashboardJobType${$scope.companyId}`,
					(-1).toString()
				);
			}
		}

		function getWorkflowNames() {
			return workflowDataService
				.getWorkflowNames()
				.map(data => successGetWorkflowNames(data));
		}

		function successGetWorkflowNames(data) {
			if (!data) {
				return false;
			}
			$scope.newJob.workflowNames = angular.copy(data);
		}

		function showNewJobModal(event) {
			const selectModal = '#addNewModal',
				nextModal = '#newJob';
			$scope.button_disable = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModalJob', $scope.newJob);
		}

		function showNewLeadModal(event) {
			const selectModal = '#addNewModal',
				nextModal = '#newLead';
			$scope.button_disable = false;
			utilsService.showNextModal(selectModal, nextModal, event);
			$scope.isCreateJobSpinnningWheelActive = false;
			$scope.$broadcast('showModal', $scope.newJob);
		}

		$scope.showAddNewJobModal = event => {
			delete $scope.newJob;
			$scope.button_disable = true;
			$scope.isAddNewSpinnningWheelActive = true;
			$scope.isDisabled = true;
			$scope.newJob = {};
			$scope.newJob.jobTypes = $scope.jobTypes;
			$scope.clients = [];

			if ($scope.defaultJobType) {
				$scope.newJob.type = $scope.defaultJobType;
			}

			getWorkflowNames()
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.isDisabled = true;
					$scope.button_disable = false;
					$scope.isAddNewSpinnningWheelActive = false;
				})
				.subscribe(() => {
					showNewJobModal(event);
				});
		};

		$scope.showAddNewLeadModal = event => {
			delete $scope.newJob;
			$scope.button_disable = true;
			$scope.addNewLeadSpinningWheel = true;
			$scope.isDisabled = true;
			$scope.newJob = {};
			$scope.newJob.jobTypes = $scope.jobTypes;
			$scope.clients = [];

			if ($scope.defaultJobType) {
				$scope.newJob.type = $scope.defaultJobType;
			}

			getWorkflowNames()
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.isDisabled = true;
					$scope.button_disable = false;
					$scope.addNewLeadSpinningWheel = false;
				})
				.subscribe(() => {
					showNewLeadModal(event);
				});
		};

		$scope.addExtraShoot = event => {
			$scope.button_disable = true;
			$scope.isAddNewSpinnningWheelActive = true;
			event.preventDefault();

			$('#addNewModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					getActiveJobs().then(() => {
						addNewEvent();
						$scope.button_disable = false;
						$scope.isAddNewSpinnningWheelActive = false;
						$('#extraShootModal').modal('show');
						$(this).off('hidden.bs.modal');
					});
				});
		};

		$scope.appointmentModal = event => {
			$scope.button_disable = true;
			$scope.isAddNewSpinnningWheelActive = true;

			$('#addNewModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					getActiveJobs().then(() => {
						addNewEvent();
						$scope.button_disable = false;
						$scope.isAddNewSpinnningWheelActive = false;
						$('#appointment').modal('show');
						$(this).off('hidden.bs.modal');
					});
				});
		};

		function addNewEvent() {
			workflowService.setTaskInfo({});
			$scope.$evalAsync();
		}

		function getActiveJobs() {
			const deferred = $q.defer();

			if (!$scope.activeJobs.length) {
				jobDataService
					.getActiveJobs()
					.then(jobs => {
						$scope.activeJobs = jobs;
						deferred.resolve(jobs);
					})
					.catch(messageService.showDefaultErrorMessage);
			} else {
				deferred.resolve($scope.activeJobs);
			}

			return deferred.promise;
		}

		$scope.sendEmailModalHandler = function({ leadId, data }) {
			$scope.showSendEmailModalSpinningWheel = true;

			Rx.Observable.zip(
				templateRequestsService.getTemplates('general_preview'),
				templateRequestsService.getTemplates('email_signature')
			)
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.showSendEmailModalSpinningWheel = false;
				})
				.subscribe(([emails, mailSignature]) => {
					$scope.mailData2Save = angular.copy(data);
					$scope.mailData2Save.emails = emails;
					$scope.mailData2Save.mailSignature = mailSignature.signature || '';

					$rootScope.clientToken = false;

					if (!$scope.$$phase) {
						$scope.$apply();
					}
					$scope.leadId = leadId;
					$scope.sendEmailLeadId = leadId || null;
					$('#sendContactEmailModal').modal('show');
				});
		};

		$scope.editJobModalHandler = job => {
			$scope.button_disable = true;
			$scope.newJob = angular.copy(job);
			prepareJob();
			$scope.$evalAsync();
		};

		function prepareJob() {
			$scope.clients = [];

			const {
				workflow,
				startDate,
				finishDate,
				primaryContact,
				secondaryContact
			} = $scope.newJob;

			$scope.newJob.oldWorkflow = workflow;

			if (!$scope.newJob.startDate) {
				$scope.newJob.hasNoDate = true;
			} else {
				$scope.dateFilterJob = 'dd/MM/yyyy';
				$scope.newJob.hasNoDate = false;
				$scope.newJob.startDate = timeService.createDateAsUTC(startDate);
				$scope.newJob.finishDate = timeService.createDateAsUTC(finishDate);
			}

			if (primaryContact) {
				const primaryClientSearchText = clientService.fillClientSearchText(
					primaryContact
				);
				$scope.clients[0] = primaryClientSearchText;
				$scope.newJob.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				const secondaryClientSearchText = clientService.fillClientSearchText(
					secondaryContact
				);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.newJob.secondaryContact = $scope.clients[1];
			}

			if (
				$scope.newJob.startDate &&
				($scope.newJob.startTime === null || $scope.newJob.finishTime === null)
			) {
				$scope.newJob.allday = true;
			}
			const type = $scope.newJob.type;
			$scope.newJob.jobTypes = $scope.jobTypes;

			getWorkflowNames()
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isCreateJobSpinnningWheelActive = false;
				})
				.subscribe(() => {
					$timeout(() => {
						$scope.newJob.type = type;
						$('#newJob').modal('show');
						$scope.isCreateJobSpinnningWheelActive = false;
						$scope.$broadcast('showModalJob', $scope.newJob);
					}, 300);
				});
		}

		$scope.editLeadModalHandler = lead => {
			$scope.button_disable = true;
			$scope.newJob = angular.copy(lead);
			prepareLead($scope.newJob);

			if ($scope.newJob.startTime) {
				$scope.newJob.startTime = timeConverter.convert24to12(
					$scope.newJob.startTime
				);

				$scope.newJob.finishTime = timeConverter.convert24to12(
					$scope.newJob.finishTime
				);
			}
		};

		$scope.updateRecentLeadsModel = function(resetPagination) {
			snCommunicationAdapter.callMethod(
				'updateRecentLeadsModel',
				resetPagination
			);
		};

		$scope.updateShootsModel = function(resetPagination) {
			snCommunicationAdapter.callMethod('updateShootsModel', resetPagination);
		};

		$scope.updateJobTasksModel = function(resetPagination) {
			snCommunicationAdapter.callMethod('updateJobTasksModel', resetPagination);
		};

		$scope.updateGraphsModel = function(tabs) {
			snCommunicationAdapter.callMethod('updateGraphsModel', tabs);
		};

		$scope.updateUpcomingPaymentsModel = function(resetPagination) {
			window.snCommunicationAdapter.callMethod(
				'updateUpcomingPaymentsModel',
				resetPagination
			);
		};

		function prepareLead() {
			$scope.clients = [];

			const {
				startDate,
				finishDate,
				primaryContact,
				secondaryContact,
				workflow
			} = $scope.newJob;

			$scope.newJob.oldWorkflow = workflow;

			if (!startDate && !finishDate) {
				$scope.newJob.hasNoDate = !!$scope.newJob.id;
			} else {
				$scope.newJob.hasNoDate = false;
				if (startDate) {
					$scope.newJob.startDate = timeService.createDateAsUTC(startDate);
				}
				if (finishDate) {
					$scope.newJob.finishDate = timeService.createDateAsUTC(finishDate);
				}
			}

			if (primaryContact) {
				const primaryClientSearchText = clientService.fillClientSearchText(
					primaryContact
				);
				$scope.clients[0] = primaryClientSearchText;
				$scope.newJob.primaryContact = $scope.clients[0];
			}

			if (secondaryContact) {
				const secondaryClientSearchText = clientService.fillClientSearchText(
					secondaryContact
				);
				$scope.clients[1] = secondaryClientSearchText;
				$scope.newJob.secondaryContact = $scope.clients[1];
			}
			if (
				$scope.newJob.startDate &&
				($scope.newJob.startTime === null || $scope.newJob.finishTime === null)
			) {
				$scope.newJob.allday = true;
			}
			const type = $scope.newJob.type;
			$scope.newJob.jobTypes = $scope.jobTypes;

			getWorkflowNames()
				.takeUntil($scope.unsubscribe)
				.finally(() => {
					$scope.button_disable = false;
					$scope.isCreateJobSpinnningWheelActive = false;
				})
				.subscribe(() => {
					$timeout(() => {
						$scope.newJob.type = type;
						$('#newLead').modal('show');
						$scope.isCreateJobSpinnningWheelActive = false;
						$scope.$broadcast('showModal', {
							lead: $scope.newJob,
							jobId: $scope.newJob.jobId
						});
					}, 300);
				});
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/homeController.js